import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/8abb1eac-9967-4968-aeab-4a2698ac7448";
export const REGISTER_URL = "https://a.ntrk2.com/8c59038d-7ca5-491c-9d30-cec99cbef472";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://mxcash.loadprkw2a.com/download?openExternalBrowser=1&id=6umes7mgfaz5jbm";

export * from "./codes";
export * from "./context";
